import { FC, useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers-pro";
import dayjs, { Dayjs } from "dayjs";
import { TraderGrantDto } from "../../api/Api";

type Props = {
  open: boolean;
  grant: TraderGrantDto | null;
  onClose: () => void;
  onSubmit: (expiresAt: string | null) => void;
  isSubmitting: boolean;
};

export const ExtendExpiryDialog: FC<Props> = ({
  open,
  grant,
  onClose,
  onSubmit,
  isSubmitting
}) => {
  const [value, setValue] = useState<Dayjs | null>(null);

  useEffect(() => {
    if (open) {
      setValue(grant?.expiresAt ? dayjs(grant.expiresAt) : null);
    }
  }, [open, grant]);

  const handleSubmit = () => {
    onSubmit(value ? value.toISOString() : null);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Change expiry</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          {grant && (
            <Typography variant="body2" color="text.secondary">
              Updating expiry for <strong>{grant.displayName}</strong>.
            </Typography>
          )}
          <DatePicker
            label="Expires on"
            value={value}
            onChange={(next) => setValue(next)}
            minDate={dayjs().add(1, "day")}
            slotProps={{
              textField: { fullWidth: true },
              actionBar: { actions: ["clear", "accept"] }
            }}
          />
          <Typography variant="caption" color="text.secondary">
            Leave blank to remove the expiry.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
